export default "__VITE_ASSET__vYSFRcHd__"